var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column min-vh-100 justify-content-center align-items-center"},[_c('router-link',{attrs:{"to":{ name: 'Home', params: { balai_id: _vm.balai } }}},[_c('img',{attrs:{"src":_vm.bg_img}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }